import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"
import styles2 from 'pages/css/rdTrf.module.css';

export const PopupViewPark = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    // 오버플로우 상태를 추적할 ref와 state
    const nmRef = React.useRef(null);
    const idRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);
    const [idOverflow, setIdOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
            setTransitionIn(true);

            // DOM이 확실히 렌더링된 후 측정
            if (nmRef.current) {
                const nmEl = nmRef.current;
                const overflow = nmEl.scrollWidth > nmEl.clientWidth;
                console.log("nmRef", { scrollWidth: nmEl.scrollWidth, clientWidth: nmEl.clientWidth, overflow });
                setNmOverflow(overflow);
            }
            if (idRef.current) {
                const idEl = idRef.current;
                const overflow = idEl.scrollWidth > idEl.clientWidth;
                console.log("idRef", { scrollWidth: idEl.scrollWidth, clientWidth: idEl.clientWidth, overflow });
                setIdOverflow(overflow);
            }
        }, 400); // Zoom in 이후에 측정되도록 타이밍 확보

        const label = {
            1: '여유',
            2: '보통',
            3: '혼잡',
            4: '매우 혼잡',
            5: '만차',
        };

        const color = {
            1 : styles2.relaxed,
            2 : styles2.normal,
            3 : styles2.busy,
            4 : styles2.veryBusy,
            5 : styles2.full,
        };

        item.lv_label = label[item.lv];
        item.lv_color = color[item.lv];
    
        return () => clearTimeout(key);
    }, [item.id, item.nm]);

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_park} gisPopup flx flx_col gap6`} style={{width:'400px'}}>
                <div className='flx a_cneter'>
                    <div className='popTit'>공영주차장</div>
                    <div className={`${styles.flow_wrap_park} flow_wrap`} ref={nmRef}>
                        <span className={`id flow_txt ${nmOverflow ? "animate-delay" : ""}`}>{item.nm}</span>
                    </div>
                </div>
                <div className='flx a_center'>
                    <div className='popTit'>주차가능대수</div>
                    <div>
                        <span className='rd' style={{fontWeight:"bold",}}>{item.remain}</span>&nbsp;&nbsp;/&nbsp;&nbsp;<span className='gr'>{item.total}</span>
                    </div>
                    {/* <div className='subTxt'>위치</div>
                    <AddressExtractor address={item.addr}/> */}
                </div>
                <div className='flx a_center'>
                    <div className='popTit'>상태</div>
                    <div>
                        <span className={`${item.lv_color}`} style={{fontWeight:"bold",}}>{item.lv_label}</span>
                    </div>
                </div>
                <div className='flx a_center'>
                    <div className='popTit'>ID</div>
                    <div>{item.id}</div>
                </div>
            </div>
        </Zoom>
    )
}

const AddressExtractor = ({ address }) => {
    const extractTextInParentheses = (text) => {
        const start = text.indexOf("(");
        const end = text.indexOf(")");  
        if (start !== -1 && end !== -1 && start < end) {
            return text.slice(start + 1, end);
        }      
        return "";
    };  
    return (
        <div>
            {extractTextInParentheses(address)}  
        </div>
    );
};